// TODO: Ultimate goal is to get rid of this file completely
// and instead break each unit of logic out into its own file
import { reactive } from 'vue'
import moment from 'moment'
import { post } from '@/helpers/api'
import {
	COOKIE_KEY,
	cookieExists,
	decryptData,
	deleteCookie,
	deserializeAccountCookie,
	encryptData,
	getAccountCookieId,
	getCookie,
	getEnv,
	getCookieDomain,
	serializeAccountCookie,
	setCookie,
} from '../helperMethods'
import {
	dbBulkPut,
	dbPut,
	deleteEntireDB,
	deleteKeyFromDB,
	deleteFromDB,
	clearTable,
	clearAllTables,
	countTableRows,
	getLogFileBlob,
	clearLogFile,
	setupDB,
} from '@/store/database'
import { getPusherInstance, forceReloadPusherInstance } from '@/helpers/pusher'
import {
	getUser,
	getMembershipForUser,
	getMyMembershipForBubble,
	importAllUsers,
	importMyMemberships,
} from './memberships'
import { clearPushToken } from '@/api/device'
import { storage, sStorage } from '@/helpers/utils'
import { downloadBlob } from '@/helpers/files'
import * as translations from './translations'
import { importMessagesFromCacheForBubble, importCursors } from './messages'
import { getChats, importAllChats } from './chats'

import * as memberships from './memberships'
import * as messages from './messages'
import * as chats from './chats'
import * as announcements from './announcements'
import * as uploads from './uploads'
import * as meetings from '@/components/Meeting/data/store'
import * as api from '@/helpers/api'
import * as emojis from '@/helpers/emojis'

import { isSafari } from './browser'
import { environments } from '@/helpers/constants'
import { startSession } from '@/helpers/session'
import { identifyAnalyticsUser } from '@/helpers/firebase'

setTimeout(() => {
	window._store = {
		memberships,
		messages,
		chats,
		announcements,
		uploads,
		emojis,
	}
	if (getEnv() === environments.PROD) return
	const pusher = getPusherInstance() || {}
	window._store = {
		...window._store,
		...store,
		pusher,
		storage,
		api,
		forceReloadPusherInstance,
		meetings,
		countTableRows,
	}
}, 500)

export const store = reactive({
	_memberships: memberships.membershipsData, // just for Vue dev tools
	_messages: messages.messagesData, // just for Vue dev tools
	_uploads: uploads.uploadData, // just for Vue dev tools
	_chats: chats.chatsData, // just for Vue dev tools
	_announcements: announcements.announcementsData, // just for Vue dev tools
	config: {},
	windowStats: {},
	threadPanelWidth: storage.get('threadPanelWidth') || 408,
	appVisible: false,
	dormantSince: null,
	askForNotificationPermission: false,
	notificationPermission: window.Notification?.permission ?? 'denied',
	isOnline: false,
	userIsActive: false,
	activeUsers: {},
	external_launch: false,
	announcements: [],
	importFiles: [],
	importbatch: {},
	integration_name: '',
	scheduledAnnouncements: [],
	unreadAnnouncements: [],
	showAnnouncementsBanner: false,
	persist: storage.get('persist') || false,
	showHideConfirm: storage.get('showHideConfirm') || true,
	recentsBubbles: [],
	uploadCompleted: false,
	uploadedMedia: {},
	lmsIntegration: false,
	language: null,
	indexedDB: true,
	termsPrompt: false,
	today: moment().utc().format('YYYY-MM-DD HH:mm:ss'),
	showNewTaskModal: false,
	currentChatId: null,
	bubbleListComplete: false,
	userKey: storage.get('userKey') || sStorage.get('userKey') || null,

	tasks: {
		open: [],
		completed: [],
		stats: {
			tasksDue: '',
			tasksUpcoming: '',
		},
	},

	livestreaming: {
		isLive: false,
		showLive: false,
		showIndicator: false,
		embedded: false,
		countingDown: false,
		videosession_id: '',
		videosession: {
			users: [],
			streamingusers: [],
		},
		publishers: [],
		startingMessageID: null,
		videoSource: null,
		initializing: false,
		isPublishing: false,
		userInitiated: false,
	},

	meeting: {
		session: null,
		streams: [],
		connections: [],
		subscribers: [],
		publisher: {},
		isPublishing: false,
	},

	async estimateStorage() {
		const { usageDetails, ...storage } = await navigator.storage.estimate()
		return Object.assign(storage, usageDetails)
	},

	async getLogFile() {
		// TODO: figure out how to make this work on FF/Safari
		const { blob } = await getLogFileBlob()
		await downloadBlob(blob)
	},

	async clearLogFile() {
		await clearLogFile()
	},

	addImportFiles(files) {
		this.importFiles.push(...files)
	},

	removeImportFile(name) {
		this.importFiles = this.importFiles.filter((f) => f.name !== name)
	},

	getActiveUserCookieId() {
		if (!this.auth.user) return null
		return getAccountCookieId(this.auth.user)
	},

	setActiveUserCookie() {
		const cookie = this.getActiveUserCookie()
		const cookie_id = this.getActiveUserCookieId()
		if (!cookie_id || !this.persist || this.persist === 'false') return

		const cookieStr = serializeAccountCookie(this.auth.user)

		// check if cookie is already up to date
		if (cookie?.raw === cookieStr) return

		setCookie(cookie_id, cookieStr, getCookieDomain())
		return { cookie_id, cookie: cookieStr }
	},

	getActiveUserCookie() {
		const cookie_id = this.getActiveUserCookieId()
		if (!cookieExists(cookie_id)) return null
		const cookieStr = getCookie(cookie_id)
		return deserializeAccountCookie(cookie_id, cookieStr)
	},

	removeActiveUserCookie() {
		const cookie_id = this.getActiveUserCookieId()
		deleteCookie(cookie_id, getCookieDomain())
	},

	clearAllCookiesForDomain() {
		this.getActiveUsers()
			.filter((u) => u.origin === window.location.origin)
			.forEach((u) => deleteCookie(u.cookie_id, getCookieDomain()))
	},

	getAllActiveUserCookies(key = COOKIE_KEY) {
		return document.cookie
			.split(';')
			.map((p) => p.trim())
			.filter((p) => p.startsWith(`${key}_`))
			.map((p) => [
				p.slice(0, p.indexOf('=')),
				p.slice(p.indexOf('=') + 1, p.length),
			])
	},

	getActiveUserIds(key = COOKIE_KEY) {
		// get all cookies that are prefixed with COOKIE_KEY value
		const cookies = this.getAllActiveUserCookies(key)
		const allIds = cookies.map(([id]) => id)
		// remove possible duplicate values for one unique set
		return Array.from(new Set(allIds))
	},

	getCookie, // TODO: remove after debugging
	deserializeAccountCookie, // TOOD: remove after debugging,

	getActiveUsers() {
		const env = getEnv()
		const nonProd = {
			cy: 'cy_test.',
			local: 'app.vite',
			dev: '.dev.',
			beta: '.beta.',
			sandbox: '.sandbox.',
		}
		return (
			this.getActiveUserIds()
				.map((id) => ({ id, cookie: getCookie(id) }))
				// filter out any bad cookies
				.filter(({ id, cookie }) => id && cookie)
				// parse out ids and cookie data
				.map(({ id, cookie }) => deserializeAccountCookie(id, cookie))
				// filter out any accounts for other envs
				.filter(({ origin }) => {
					// based on env, check the cookie's origin property
					// TODO: we should just store the env in the cookie so we don't
					// have to rely on parsing the origin every time
					if (env === environments.PROD) {
						return Object.values(nonProd).every((str) => !origin.includes(str))
					}
					return origin.includes(nonProd[env])
				})
		)
	},

	// TODO: remove this in favor of getNotificationPreference() in memberships.js
	getNotificationPreference(group_id) {
		const { notificationpreference } = this.auth.user

		if (group_id) {
			const membership = getMyMembershipForBubble(group_id)
			const chat = chats.getChat(group_id)

			if (
				chat?.is_supergroup &&
				membership?.notificationpreference === 'DEFAULT_INHERIT'
			) {
				return 'MENTIONS'
			}

			if (
				membership &&
				membership.notificationpreference !== 'DEFAULT_INHERIT'
			) {
				return membership.notificationpreference === 'MENTIONS_EXCLUDE_ALL'
					? 'MENTIONS'
					: membership.notificationpreference
			}

			// Thread fallback: check parent chat preference before user preference
			if (chat?.is_thread && chat?.parent_chat_id) {
				const parentMembership = getMyMembershipForBubble(chat.parent_chat_id)
				const parentPref = parentMembership?.notificationpreference
				if (parentPref && parentPref !== 'DEFAULT_INHERIT') {
					return parentPref === 'MENTIONS_EXCLUDE_ALL' ? 'MENTIONS' : parentPref
				}
			}

			return this.auth.user.notificationpreference
		} else {
			return notificationpreference
		}
	},

	async setNotificationPreference(groupPreference, payload) {
		if (groupPreference) {
			const membership = getMyMembershipForBubble(payload.bubble_id)
			if (!membership) return

			const previous_preference = membership.notificationpreference

			membership.notificationpreference = payload.notificationpreference

			try {
				const { data } = await post('/api/v1/membership.update', payload)
				return data
			} catch (e) {
				console.error(e)
				membership.notificationpreference = previous_preference
				prontoAlert.error()
			}
		} else {
			this.auth.user.notificationpreference = payload.notificationpreference
			try {
				const { data } = await post('/api/v1/user.update', payload)
				return data
			} catch (e) {
				console.error(e)
			}
		}
	},

	getAlias(bubbleId) {
		return this.nicknames[bubbleId]
	},

	setAlias(bubbleId, alias) {
		this.nicknames[bubbleId] = alias
	},

	getCategoryAlias(categoryId) {
		return this.categoryNicknames[categoryId]
	},

	setCategoryAlias(categoryId, alias) {
		this.categoryNicknames[categoryId] = alias
	},

	mediaPath({ url }) {
		if (!url || !url.includes?.('pronto.io')) return url

		// change origin from files.pronto.io to app origin so the app's cookie
		// is included in the request for authentication
		const mediaUrl = new URL(url)
		let adjustedUrl = new URL(
			url.replace(mediaUrl.origin, window.location.origin)
		)

		// check if we need a media token to be included as well
		const { config, auth } = this
		const needsToken =
			config.env === 'local' ||
			config.wrapper ||
			config.embedded ||
			config.integration_name ||
			// Standalone activity route (Canvas/LTI SpeedGrader) renders without
			// Home, so it has no embedded/integration flag. Only append the token
			// when actually inside a (cross-origin) iframe — the app cookie isn't
			// sent there. Opened directly in a tab, the cookie works and we skip
			// the token to keep media CDN-cacheable.
			(window.location.pathname.startsWith('/activity') &&
				window.self !== window.top)
		if (needsToken && auth.media_token?.accessToken) {
			adjustedUrl.searchParams.set('t', auth.media_token.accessToken)
		}

		return adjustedUrl.toString()
	},

	mediaThumbnailPath({ thumbnail_url }) {
		return this.mediaPath({ url: thumbnail_url })
	},

	userProfile({ profilepicurl, profilepicpath, role }) {
		if (role === 'support' || profilepicurl === null) return profilepicurl
		return this.mediaPath({ url: profilepicurl, path: profilepicpath })
	},

	updateTaskStats() {
		let tasksDue = 0
		let tasksUpcoming = 0
		const today = moment().local().format('YYYY-MM-DD')

		this.tasks.open
			.filter((t) => t.assigneeuser_id === this.auth.user.id)
			.map((t) => moment(t.due))
			.forEach((dueDate) => {
				if (dueDate.isAfter(today)) {
					tasksUpcoming++
				} else {
					tasksDue++
				}
			})

		this.tasks.stats.tasksDue = tasksDue
		this.tasks.stats.tasksUpcoming = tasksUpcoming
	},

	getUser(userId) {
		return getUser(userId)
	},

	calcAllExternalUnreads() {
		const unreadTasks = this.tasks.stats.tasksDue || 0
		const unreadAnnouncments = this.unreadAnnouncements.length || 0
		const unreadMessages = getChats().reduce((sum, c) => {
			if (c.ishidden) return sum
			if (c.mute) return sum + chats.getEffectiveMentions(c)
			return this.getNotificationPreference(c.id) === 'ALL'
				? sum + (c.unread || 0)
				: sum + (c.unread_mentions || 0)
		}, 0)

		return unreadTasks + unreadAnnouncments + unreadMessages
	},

	translations,
	category: {
		expand(category_id) {
			let categories = storage.get('expandedCategories')
			categories.push(category_id)
			storage.set('expandedCategories', categories)
		},
		collapse(category_id) {
			let categories = storage.get('expandedCategories')
			const idx = categories.findIndex((t) => t === category_id)
			if (idx > -1) {
				categories.splice(idx, 1)
				storage.set('expandedCategories', categories)
			}
		},
		reset() {
			storage.remove('expandedCategories')
		},
	},

	coursesInit() {},

	courses: {
		check(course_id) {
			let courseXref = storage.get('coursesXref')
			if (!courseXref) {
				this.init()
				return false
			} else {
				let position = courseXref.findIndex((obj) => obj.course_id == course_id)
				if (position > -1) {
					return courseXref[position]
				} else {
					return false
				}
			}
		},

		add(course_id, group_id) {
			let courseXref = storage.get('coursesXref')
			let xref = {
				course_id: course_id,
				group_id: group_id,
			}

			courseXref.push(xref)
			storage.set('coursesXref', courseXref)
		},

		init() {
			let courseArray = []
			storage.set('coursesXref', courseArray)
		},
	},

	groups: {
		check(group_id) {
			let groupXref = storage.get('groupXref')
			if (!groupXref) {
				this.init()
				return false
			} else {
				let position = groupXref.findIndex((obj) => obj.group_id == group_id)
				if (position > -1) {
					return groupXref[position]
				} else {
					return false
				}
			}
		},

		add(group_id, pronto_group_id) {
			let groupXref = storage.get('groupXref')
			let xref = {
				group_id: group_id,
				pronto_group_id: pronto_group_id,
			}

			groupXref.push(xref)
			storage.set('groupXref', groupXref)
		},

		init() {
			let groupArray = []
			storage.set('groupXref', groupArray)
		},
	},

	auth: {
		api_token: null,
		user: null,
		media_token: null,
		device_uuid: null,
		loggedin: false,
		integration_jwt: null,

		setIntegrationJwt(jwtObj, userKey) {
			if (jwtObj && jwtObj.token) {
				storage.set('integration_jwt', encryptData(jwtObj, userKey))
				this.integration_jwt = jwtObj
			}
		},

		removeIntegrationJwt() {
			storage.remove('integration_jwt')
			this.integration_jwt = null
		},

		initialize(userKey) {
			if (storage.get('api_token')) {
				try {
					this.api_token = decryptData(storage.get('api_token'), userKey)
				} catch (error) {
					EventBus.$emit('logoutUser')
				}
			} else {
				this.api_token = null
			}

			if (this.api_token) {
				try {
					//TODO: CREATE A PROMISE HERE SO THAT NOTHING ELSE HAPPENS UNTIL THIS HAS FULLY COMPLETED...
					this.user = decryptData(storage.get('user'), userKey)
					if (window.location.search.includes('userIsActive=1')) {
						this.user.hasactivity = true
					}
				} catch (error) {
					EventBus.$emit('logoutUser')
				}
				this.device_uuid = storage.get('device_uuid')
				this.media_token = storage.get('media_token')
					? storage.get('media_token')
					: null
				this.loggedin = true
			} else {
				store.clearAllCookiesForDomain()
				this.loggedin = false
				this.user = null
				this.media_token = null
			}

			if (storage.get('integration_jwt')) {
				try {
					this.integration_jwt = decryptData(
						storage.get('integration_jwt'),
						userKey
					)
				} catch (error) {
					storage.remove('integration_jwt')
					this.integration_jwt = null
				}
			}

			//storage.set('encryptedUser', encryptData(this.user));
		},
		isAdmin() {
			return this.user.role === 'admin'
		},
		set(api_token, media_token, user, userKey, persist_state, device_uuid) {
			const wasPersisted = storage.get('persist')
			const previousUserKey = storage.get('userKey') || sStorage.get('userKey')
			storage.set('persist', persist_state)

			const persistChanged = wasPersisted !== persist_state
			const userKeyChanged = previousUserKey && previousUserKey !== userKey

			if (persistChanged || userKeyChanged) {
				// stale ciphertext can't be read with a different key — wipe before reseeding
				console.debug('clearing all db tables...', {
					persistChanged,
					userKeyChanged,
				})
				store.dbClearAllTables()
			}

			this.setUser(user, userKey, persist_state)
			storage.set('api_token', encryptData(api_token, userKey))
			setCookie('api_token', api_token)

			if (typeof device_uuid !== 'undefined') {
				storage.set('device_uuid', device_uuid)
			} else {
				storage.remove('device_uuid')
			}

			if (typeof media_token !== 'undefined') {
				storage.set('media_token', media_token)
			} else {
				storage.remove('media_token')
			}

			//TODO should we create a random key??? Or not??? Because how do I persist it??? Where do I store it??

			if (persist_state !== 'false' && persist_state !== false) {
				storage.set('userKey', userKey)
			} else {
				sStorage.set('userKey', userKey)
			}

			//since we're setting a new api_token we should remove our pushtoken associated with it.  This guards against users who don't properly logout...
			clearPushToken()

			this.initialize(userKey)
		},
		resetMediaToken(media_token) {
			storage.remove('media_token')
			storage.set('media_token', media_token)
			this.media_token = storage.get('media_token')
		},
		async ensureMediaToken() {
			// Mint on demand when missing or within 6 min of expiry. Mirrors
			// Home.vue's old checkMediaTokenTTL/createMediaToken so Home chrome
			// and the standalone activity iframe (which has no Home) share one
			// code path.
			const token = this.media_token
			if (token?.accessToken) {
				const ttlTime = moment.unix(token.ttl).local()
				const minutesLeft = moment(ttlTime).diff(moment().utc(), 'minutes')
				if (minutesLeft >= 6) return token
			}
			try {
				const { data } = await post('/api/v1/mediatoken.create')
				this.resetMediaToken(data.mediatoken)
				return this.media_token
			} catch (error) {
				console.error(error)
				return null
			}
		},
		remove() {
			storage.remove('api_token')
			storage.remove('user')
			clearPushToken()
			storage.remove('userKey')
			storage.remove('device_uuid')
			storage.remove('media_token')
			storage.remove('acceptedtos')
			storage.remove('logging_enabled')
			storage.remove('showHideConfirm')
			sStorage.remove('userKey')
			storage.remove('integration_jwt')
			this.initialize('removed')
		},
		setUser(user, userKey, persist) {
			this.user = user
			memberships.setUser(user)
			setupDB(userKey, persist)
			storage.set('user', encryptData(user, userKey))
			startSession()
			identifyAnalyticsUser()
		},
	},
	setApiTokenCookie(api_token) {
		api_token = api_token || this.auth.api_token
		const previous = getCookie('api_token')
		if (api_token && api_token !== previous) {
			setCookie('api_token', api_token)
		}
	},
	sortedUserList(list) {
		function compareByName(a, b) {
			var aName = a.name.toLowerCase()
			var bName = b.name.toLowerCase()

			if (aName < bName) {
				return -1
			}

			if (aName > bName) {
				return 1
			}

			return 0
		}

		return list.sort(compareByName)
	},
	sortedGroupList(list) {
		function compareByTitle(a, b) {
			var aTitle = a.title.toLowerCase()
			var bTitle = b.title.toLowerCase()

			if (aTitle < bTitle) {
				return -1
			}

			if (aTitle > bTitle) {
				return 1
			}

			return 0
		}

		return list.sort(compareByTitle)
	},

	isHitlabs() {
		//the line below will turn livestreaming off...
		// return false;
		if (this.auth.user.organizations[0].id === 2) {
			return true
		} else {
			return false
		}
	},

	getInitials(user) {
		if (user.firstname && user.lastname) {
			return user.firstname.substr(0, 1) + user.lastname.substr(0, 1)
		} else if (user.firstname && !user.lastname) {
			return user.firstname.substr(0, 1)
		} else if (!user.firstname && !user.lastname) {
			return ''
		}
		//return user_name.firstname.substr(0,1) + user_name.lastname.substr(0,1);
	},

	getUserName(user) {
		if (user.firstname && user.lastname) {
			return user.firstname + ' ' + user.lastname
		} else if (user.firstname && !user.lastname) {
			return user.firstname
		} else if (!user.firstname && !user.lastname) {
			return 'Unknown User'
		}
	},

	checkOrgPermission(permission) {
		try {
			const role = this.auth.user.role
			const orgPerm = this.auth.user.organizations[0][permission]

			if (
				orgPerm === role ||
				role === 'admin' ||
				orgPerm === 'user' ||
				role === 'support'
			) {
				return true
				// all other mismatches fall through
			} else if (orgPerm !== role) {
				return false
			}
		} catch (error) {
			console.error(error)
		}
	},

	tasksEnabled() {
		return this.auth.user.organizations[0].tasks_enabled
	},

	getMembershipRole(user_id) {
		const membership = getMembershipForUser(user_id)
		return membership ? membership.role : null
	},

	seedDB() {
		importAllUsers()
		importMyMemberships()
		importCursors()
		importAllChats()
	},

	shouldSkipDB() {
		if (window.Cypress) return true
		return isSafari && (this.config.embedded || this.config.wrapper)
	},

	dbPut(tableName, data) {
		if (this.shouldSkipDB()) return
		dbPut(tableName, data)
	},

	dbBulkPut(tableName, items) {
		if (this.shouldSkipDB()) return
		dbBulkPut(tableName, items)
	},

	async dbLoadChat(group_id) {
		if (this.shouldSkipDB()) return

		try {
			await importMessagesFromCacheForBubble(group_id)
		} catch (error) {
			console.error('Cannot decrypt our data', error)
		}
	},

	dbDeleteByColumn(tableName, column, key) {
		if (this.shouldSkipDB()) return
		deleteFromDB(tableName, { [column]: key })
	},

	dbDeleteByKey(tableName, primaryKey) {
		if (this.shouldSkipDB()) return
		deleteKeyFromDB(tableName, primaryKey)
	},

	async dbDeleteDatabase() {
		if (this.shouldSkipDB()) return
		await deleteEntireDB()
	},

	dbClearTable(tableName) {
		if (this.shouldSkipDB()) return
		clearTable(tableName)
	},

	async dbClearAllTables() {
		if (this.shouldSkipDB()) return
		await clearAllTables()
	},
})

export default store
